import s from '@features/QuickSearch/ui/QuickSearchOutput/QuickSearchOutput.module.sass'
import { matchByField } from '@shared/lib/helpers/matchByField'
import { QuickSearchPlaceItem } from '@features/QuickSearch/ui/QuickSearchPlaceItem'
import { Button } from '@shared/ui/Actions/Button'
import { EGG } from '@shared/api/analytics'
import React, { FC } from 'react'
import { QuickSearchItemType } from '@features/QuickSearch/useQuickSearch'

export interface PropsQuickSearchOutputList {
  list: QuickSearchItemType[]
  onClickAllResults: () => void
  onClickItem: () => void
}

const QuickSearchOutputList: FC<PropsQuickSearchOutputList> = ({ list, onClickAllResults, onClickItem }) => {
  return (
    <>
      <ul className={s.list}>
        {list.map((item, index) =>
          matchByField(item, '__typename', {
            Place: (place) => (
              <QuickSearchPlaceItem key={place.id} place={place} index={index} onClickLink={onClickItem} />
            ),
            // просто заготовка под подборки со статьями
            Article: () => <></>,
          }),
        )}
      </ul>
      <div className={s['all-results-button']}>
        <Button
          sizes='L'
          mode='black'
          onClick={() => {
            EGG.quickSearch.all_results_click()
            onClickAllResults()
          }}
          className={s['extended-button']}>
          Все результаты
        </Button>
      </div>
    </>
  )
}

export default QuickSearchOutputList
